import dynamic from "next/dynamic";

// These galaxies are managed by normal Next.js routing, templating, etc. They
// are not handled by [[...slugs]].tsx which somewhat reinvents the wheel.
export const galaxiesExcludedFromSlugProcessing = [
  "accelerators",
  "blog",
  "community",
  "webinars",
];

// TODO: make these auto generated somehow (use markdown to html method?)
// https://github.com/vercel/next.js/discussions/11291#discussioncomment-4504
export type Documents = { [key: string]: React.ComponentType };
export const documents: Documents = {
  "cellwifi-quickstart": dynamic(
    () => import(`./quickstart/01 Cell+WiFi Quickstart/_main.mdx`),
  ),
  "lorawan-quickstart": dynamic(
    () => import(`./quickstart/05 LoRaWAN Quickstart/_main.mdx`),
  ),
  "starnote-quickstart": dynamic(
    () => import(`./quickstart/07 Starnote Quickstart/_main.mdx`),
  ),
  "wireless-for-arduino-opta-quickstart": dynamic(
    () =>
      import(`./quickstart/09 Wireless for Arduino Opta Quickstart/_main.mdx`),
  ),
  "notecard-quickstart": dynamic(
    () => import(`./quickstart/10 Notecard Quickstart/_main.mdx`),
  ),
  "notecard-lora-quickstart": dynamic(
    () => import(`./quickstart/15 Notecard LoRa Quickstart/_main.mdx`),
  ),
  "cygnet-quickstart": dynamic(
    () => import(`./quickstart/18 Cygnet Quickstart/_main.mdx`),
  ),
  "swan-quickstart": dynamic(
    () => import(`./quickstart/20 Swan Quickstart/_main.mdx`),
  ),
  "mojo-quickstart": dynamic(
    () => import(`./quickstart/35 Mojo Quickstart/_main.mdx`),
  ),
  "sparrow-quickstart": dynamic(
    () => import(`./quickstart/90 Sparrow Quickstart/_main.mdx`),
  ),
  "collecting-sensor-data": dynamic(
    () => import(`./guides-and-tutorials/10 Collecting Sensor Data/_main.mdx`),
  ),
  "routing-data-to-cloud": dynamic(
    () => import(`./guides-and-tutorials/20 Routing Data to Cloud/_main.mdx`),
  ),
  "building-edge-ml-applications": dynamic(
    () =>
      import(
        `./guides-and-tutorials/30 Building Edge ML Applications/_main.mdx`
      ),
  ),
  "best-practices-for-production-ready-projects": dynamic(
    () =>
      import(
        `./guides-and-tutorials/40 Best Practices for Production-Ready Projects/_main.mdx`
      ),
  ),
  "twilio-sms-guide": dynamic(
    () => import(`./guides-and-tutorials/50 Twilio SMS Guide/_main.mdx`),
  ),
  "fleet-admin-guide": dynamic(
    () => import(`./guides-and-tutorials/60 Fleet Admin Guide/_main.mdx`),
  ),
  "using-the-notehub-api": dynamic(
    () => import(`./guides-and-tutorials/70 Using the Notehub API/_main.mdx`),
  ),
  "zzz-test": dynamic(() => import(`./quickstart/99 ZZZ Test/_main.mdx`)),
  "system-notefiles": dynamic(
    () => import(`./api-reference/03 System Notefiles/_main.mdx`),
  ),
  introduction: dynamic(
    () => import(`./api-reference/04 Notecard API/00 Introduction/_main.mdx`),
  ),
  "card-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/01 card Requests/_main.mdx`),
  ),
  "dfu-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/02 dfu Requests/_main.mdx`),
  ),
  "env-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/03 env Requests/_main.mdx`),
  ),
  "file-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/04 file Requests/_main.mdx`),
  ),
  "hub-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/05 hub Requests/_main.mdx`),
  ),
  "note-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/06 note Requests/_main.mdx`),
  ),
  "ntn-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/07 ntn Requests/_main.mdx`),
  ),
  "var-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/08 var Requests/_main.mdx`),
  ),
  "web-requests": dynamic(
    () => import(`./api-reference/04 Notecard API/09 web Requests/_main.mdx`),
  ),
  "notecard-firmware-releases": dynamic(
    () => import(`./notecard/03 Notecard Firmware Releases/_main.mdx`),
  ),
  overview: dynamic(
    () => import(`./notecard/04 Notecard Walkthrough/01 Overview/_main.mdx`),
  ),
  "notecard-product-family": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/02 Notecard Product Family/_main.mdx`
      ),
  ),
  "notecard-requests-and-responses": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/03 Notecard Requests & Responses/_main.mdx`
      ),
  ),
  "json-fundamentals": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/04 JSON Fundamentals/_main.mdx`
      ),
  ),
  "notecard-interfaces": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/05 Notecard Interfaces/_main.mdx`
      ),
  ),
  "essential-requests": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/06 Essential Requests/_main.mdx`
      ),
  ),
  "time-and-location-requests": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/07 Time & Location Requests/_main.mdx`
      ),
  ),
  "inbound-requests-and-shared-data": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/08 Inbound Requests & Shared Data/_main.mdx`
      ),
  ),
  "web-transactions": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/09 Web Transactions/_main.mdx`
      ),
  ),
  "low-power-design": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/10 Low Power Design/_main.mdx`
      ),
  ),
  "low-bandwidth-design": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/11 Low Bandwidth Design/_main.mdx`
      ),
  ),
  "working-with-the-notecard-aux-pins": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/12 Working with the Notecard AUX Pins/_main.mdx`
      ),
  ),
  "updating-notecard-firmware": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/13 Updating Notecard Firmware/_main.mdx`
      ),
  ),
  "advanced-notecard-configuration": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/14 Advanced Notecard Configuration/_main.mdx`
      ),
  ),
  "notecard-error-and-status-codes": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/15 Notecard Error and Status Codes/_main.mdx`
      ),
  ),
  "notecard-certifications": dynamic(
    () =>
      import(
        `./notecard/04 Notecard Walkthrough/16 Notecard Certifications/_main.mdx`
      ),
  ),

  glossary: dynamic(() => import(`./api-reference/01 Glossary/_main.mdx`)),
  "notecard-cli": dynamic(
    () => import(`./tools-and-sdks/01 Notecard CLI/_main.mdx`),
  ),
  "libraries-overview": dynamic(
    () =>
      import(
        `./tools-and-sdks/02 Firmware Libraries/01 Libraries Overview/_main.mdx`
      ),
  ),
  "arduino-library": dynamic(
    () =>
      import(
        `./tools-and-sdks/02 Firmware Libraries/02 Arduino Library/_main.mdx`
      ),
  ),
  "python-library": dynamic(
    () =>
      import(
        `./tools-and-sdks/02 Firmware Libraries/03 Python Library/_main.mdx`
      ),
  ),
  "zephyr-library": dynamic(
    () =>
      import(
        `./tools-and-sdks/02 Firmware Libraries/04 Zephyr Library/_main.mdx`
      ),
  ),
  "sdks-overview": dynamic(
    () => import(`./tools-and-sdks/03 Notehub SDKs/01 SDKs Overview/_main.mdx`),
  ),
  "notehub-js-library": dynamic(
    () =>
      import(
        `./tools-and-sdks/03 Notehub SDKs/02 Notehub JS Library/_main.mdx`
      ),
  ),
  "notehub-py-library": dynamic(
    () =>
      import(
        `./tools-and-sdks/03 Notehub SDKs/03 Notehub Py Library/_main.mdx`
      ),
  ),
  "notehub-walkthrough": dynamic(
    () => import(`./notehub/10 Notehub Walkthrough/_main.mdx`),
  ),
  "host-dfu-overview": dynamic(
    () =>
      import(
        `./notehub/35 Host Firmware Updates/01 Host DFU Overview/_main.mdx`
      ),
  ),
  "notecard-outboard-firmware-update": dynamic(
    () =>
      import(
        `./notehub/35 Host Firmware Updates/02 Notecard Outboard Firmware Update/_main.mdx`
      ),
  ),
  "iap-firmware-update": dynamic(
    () =>
      import(
        `./notehub/35 Host Firmware Updates/03 IAP Firmware Update/_main.mdx`
      ),
  ),
  "notehub-api-requests-for-dfu": dynamic(
    () =>
      import(
        `./notehub/35 Host Firmware Updates/04 Notehub API Requests for DFU/_main.mdx`
      ),
  ),
  "notecard-api-requests-for-dfu": dynamic(
    () =>
      import(
        `./notehub/35 Host Firmware Updates/05 Notecard API Requests for DFU/_main.mdx`
      ),
  ),
  "environment-variables-for-dfu": dynamic(
    () =>
      import(
        `./notehub/35 Host Firmware Updates/06 Environment Variables for DFU/_main.mdx`
      ),
  ),
  "configuring-a-slack-route": dynamic(
    () => import(`./notehub/40 Configuring a Slack Route/_main.mdx`),
  ),
  "configuring-an-amazon-s3-route": dynamic(
    () => import(`./notehub/50 Configuring an Amazon S3 Route/_main.mdx`),
  ),
  "configuring-an-arduino-iot-cloud-route": dynamic(
    () =>
      import(`./notehub/60 Configuring an Arduino IoT Cloud Route/_main.mdx`),
  ),
  "configuring-a-snowpipe-route": dynamic(
    () => import(`./notehub/70 Configuring a Snowpipe Route/_main.mdx`),
  ),
  "api-introduction": dynamic(
    () =>
      import(`./api-reference/05 Notehub API/00 API Introduction/_main.mdx`),
  ),
  "authorization-api": dynamic(
    () =>
      import(`./api-reference/05 Notehub API/10 Authorization API/_main.mdx`),
  ),
  "billing-account-api": dynamic(
    () =>
      import(`./api-reference/05 Notehub API/20 Billing Account API/_main.mdx`),
  ),
  "device-api": dynamic(
    () => import(`./api-reference/05 Notehub API/30 Device API/_main.mdx`),
  ),
  "event-api": dynamic(
    () => import(`./api-reference/05 Notehub API/40 Event API/_main.mdx`),
  ),
  "monitor-api": dynamic(
    () => import(`./api-reference/05 Notehub API/50 Monitor API/_main.mdx`),
  ),
  "project-api": dynamic(
    () => import(`./api-reference/05 Notehub API/60 Project API/_main.mdx`),
  ),
  "route-api": dynamic(
    () => import(`./api-reference/05 Notehub API/70 Route API/_main.mdx`),
  ),
  "notecard-datasheet": dynamic(
    () => import(`./datasheets/01 Notecard Datasheet/_main.mdx`),
  ),
  "notecarrier-datasheet": dynamic(
    () => import(`./datasheets/05 Notecarrier Datasheet/_main.mdx`),
  ),
  "notecarrier-a-series-solar-jst-input": dynamic(
    () =>
      import(
        `./datasheets/30 Application Notes/01 Notecarrier A Series Solar JST Input/_main.mdx`
      ),
  ),
  "notecard-host-system-design-guide": dynamic(
    () =>
      import(
        `./datasheets/30 Application Notes/02 Notecard Host System Design Guide/_main.mdx`
      ),
  ),
  "future-proofing-notecard-based-designs": dynamic(
    () =>
      import(
        `./datasheets/30 Application Notes/03 Future-Proofing Notecard-Based Designs/_main.mdx`
      ),
  ),
  "low-power-hardware-design": dynamic(
    () =>
      import(
        `./datasheets/30 Application Notes/04 Low-Power Hardware Design/_main.mdx`
      ),
  ),
  "designing-for-xp-variants-of-the-blues-notecard": dynamic(
    () =>
      import(
        `./datasheets/30 Application Notes/05 Designing for XP Variants of the Blues Notecard/_main.mdx`
      ),
  ),
  "airnote-datasheet": dynamic(
    () => import(`./datasheets/35 Airnote Datasheet/_main.mdx`),
  ),
  "scoop-datasheet": dynamic(
    () => import(`./datasheets/25 Scoop Datasheet/_main.mdx`),
  ),
  "mojo-datasheet": dynamic(
    () => import(`./datasheets/18 Mojo Datasheet/_main.mdx`),
  ),
  "sparrow-datasheet": dynamic(
    () => import(`./datasheets/20 Sparrow Datasheet/_main.mdx`),
  ),
  "cygnet-datasheet": dynamic(
    () => import(`./datasheets/14 Cygnet Datasheet/_main.mdx`),
  ),
  "swan-datasheet": dynamic(
    () => import(`./datasheets/15 Swan Datasheet/_main.mdx`),
  ),
  "wireless-for-arduino-opta-datasheet": dynamic(
    () =>
      import(`./datasheets/17 Wireless for Arduino Opta Datasheet/_main.mdx`),
  ),
  "guide-listing": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/05 Guide Listing/_main.mdx`
      ),
  ),
  "asset-tracking": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/10 Asset Tracking/_main.mdx`
      ),
  ),
  "attention-pin-guide": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/15 Attention Pin Guide/_main.mdx`
      ),
  ),
  "connecting-to-a-wi-fi-access-point": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/20 Connecting to a Wi-Fi Access Point/_main.mdx`
      ),
  ),
  "debugging-with-the-ftdi-debug-cable": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/25 Debugging with the FTDI Debug Cable/_main.mdx`
      ),
  ),
  "diagnosing-cellular-connectivity-issues": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/30 Diagnosing Cellular Connectivity Issues/_main.mdx`
      ),
  ),
  "diagnosing-gps-issues": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/32 Diagnosing GPS Issues/_main.mdx`
      ),
  ),
  "encrypting-and-decrypting-data-with-the-notecard": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/35 Encrypting and Decrypting Data with the Notecard/_main.mdx`
      ),
  ),
  "feather-mcu-low-power-management": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/37 Feather MCU Low Power Management/_main.mdx`
      ),
  ),
  "minimizing-latency": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/40 Minimizing Latency/_main.mdx`
      ),
  ),
  "notecard-communication-without-a-library": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/45 Notecard Communication Without a Library/_main.mdx`
      ),
  ),
  "recovering-a-bricked-notecard": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/53 Recovering a Bricked Notecard/_main.mdx`
      ),
  ),
  "remote-command-and-control": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/55 Remote Command and Control/_main.mdx`
      ),
  ),
  "sending-and-receiving-large-binary-objects": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/58 Sending and Receiving Large Binary Objects/_main.mdx`
      ),
  ),
  "serial-over-i2c-protocol": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/60 Serial-Over-I2C Protocol/_main.mdx`
      ),
  ),
  "understanding-environment-variables": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/65 Understanding Environment Variables/_main.mdx`
      ),
  ),
  "understanding-notecard-penalty-boxes": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/70 Understanding Notecard Penalty Boxes/_main.mdx`
      ),
  ),
  "updating-esp32-host-firmware": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/75 Updating ESP32 Host Firmware/_main.mdx`
      ),
  ),
  "using-external-sim-cards": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/80 Using External SIM Cards/_main.mdx`
      ),
  ),
  "using-jsonata-to-transform-json": dynamic(
    () =>
      import(
        `./guides-and-tutorials/80 Notecard Guides/85 Using JSONata to Transform JSON/_main.mdx`
      ),
  ),
  "cygnet-introduction": dynamic(
    () => import(`./feather-mcus/10 Cygnet/10 Cygnet Introduction/_main.mdx`),
  ),
  "using-arduino-ide-with-cygnet": dynamic(
    () =>
      import(
        `./feather-mcus/10 Cygnet/30 Using Arduino IDE with Cygnet/_main.mdx`
      ),
  ),
  "using-stm32cubeide-with-cygnet": dynamic(
    () =>
      import(
        `./feather-mcus/10 Cygnet/40 Using STM32CubeIDE with Cygnet/_main.mdx`
      ),
  ),
  "swan-introduction": dynamic(
    () => import(`./feather-mcus/20 Swan/10 Swan Introduction/_main.mdx`),
  ),
  "using-arduino-ide-with-swan": dynamic(
    () =>
      import(`./feather-mcus/20 Swan/50 Using Arduino IDE with Swan/_main.mdx`),
  ),
  "using-circuitpython-with-swan": dynamic(
    () =>
      import(
        `./feather-mcus/20 Swan/60 Using CircuitPython with Swan/_main.mdx`
      ),
  ),
  "using-stm32cubeide-with-swan": dynamic(
    () =>
      import(
        `./feather-mcus/20 Swan/65 Using STM32CubeIDE with Swan/_main.mdx`
      ),
  ),
  "recovering-the-stm32l4r5": dynamic(
    () =>
      import(`./feather-mcus/20 Swan/70 Recovering the STM32L4R5/_main.mdx`),
  ),

  "frequently-asked-questions": dynamic(
    () => import(`./faq/01 Frequently Asked Questions/_main.mdx`),
  ),

  "connecting-to-a-lorawan-gateway": dynamic(
    () => import(`./lora/10 Connecting to a LoRaWAN Gateway/_main.mdx`),
  ),
  "building-your-first-lora-app": dynamic(
    () => import(`./lora/30 Building Your First LoRa App/_main.mdx`),
  ),
  sparrow: dynamic(() => import(`./lora/35 Sparrow/_main.mdx`)),

  "starnote-best-practices": dynamic(
    () => import(`./starnote/10 Starnote Best Practices/_main.mdx`),
  ),
  "starnote-datasheet": dynamic(
    () => import(`./datasheets/10 Starnote Datasheet/_main.mdx`),
  ),

  "sdk-examples": dynamic(
    () => import(`./example-apps/05 SDK Examples/_main.mdx`),
  ),
  "sample-apps-list": dynamic(
    () => import(`./example-apps/10 Sample Apps/01 Sample Apps List/_main.mdx`),
  ),
  "continuous-asset-tracking-with-external-gps-and-immediate-location-sync":
    dynamic(
      () =>
        import(
          `./example-apps/10 Sample Apps/10 Continuous Asset Tracking with External GPS and Immediate Location Sync/_main.mdx`
        ),
    ),
  "managing-a-notecards-wi-fi-network-remotely": dynamic(
    () =>
      import(
        `./example-apps/10 Sample Apps/13 Managing a Notecard's Wi-Fi Network Remotely/_main.mdx`
      ),
  ),
  "putting-a-host-to-sleep-between-sensor-readings": dynamic(
    () =>
      import(
        `./example-apps/10 Sample Apps/15 Putting a Host to Sleep Between Sensor Readings/_main.mdx`
      ),
  ),
  "sending-inbound-notes-and-receiving-acknowledgment": dynamic(
    () =>
      import(
        `./example-apps/10 Sample Apps/20 Sending Inbound Notes and Receiving Acknowledgment/_main.mdx`
      ),
  ),
  "using-leds-and-neopixels-to-monitor-notecard-status": dynamic(
    () =>
      import(
        `./example-apps/10 Sample Apps/30 Using LEDs and NeoPixels to Monitor Notecard Status/_main.mdx`
      ),
  ),
};
